import { getLocalStorage } from '@/utils/localStorage';

// 用户是否登录
export const getIsLogin = () => {
  return !!getLocalStorage('ticket');
};

// 获取用户ticket
export const getTicket = () => {
  return getLocalStorage('ticket');
};
